import carbonNeutralIcon from './assets/carbon-neutral.svg';
import localSupportIcon from './assets/local-support.svg';
import securePaymentIcon from './assets/secure-payment.svg';
import shippingIcon from './assets/shipping.svg';
import starChatIcon from './assets/star-chat.svg';
import thumbsUpIcon from './assets/thumb-up.svg';
import type { TrustSignalProps } from './TrustSignal';

import { TrustSignal } from './TrustSignal';
import {
  carbonNeutralUrl,
  helpCenterUrl,
  returnExchangePolicyHelpUrl,
  securePaymentsHelpUrl,
  shippingHelpUrl,
} from './urls';

export {
  TrustSignal,
  TrustSignalProps,
  carbonNeutralIcon,
  localSupportIcon,
  securePaymentIcon,
  shippingIcon,
  starChatIcon,
  thumbsUpIcon,
  shippingHelpUrl,
  securePaymentsHelpUrl,
  returnExchangePolicyHelpUrl,
  helpCenterUrl,
  carbonNeutralUrl,
};
